import type {FC} from 'react';
import {useNavigate} from 'react-router';

import type {WithChildren} from '@yourcoach/shared/utils/utility-types';

import {ContainerExtend} from '@yourcoach/shared/IoC/components/ContainerExtend';

import {createNavigationModule} from '@src/v2/services/navigation/Navigation.service';

export const NavigationServiceProvider: FC<WithChildren> = ({children}) => {
  const navigate = useNavigate();

  return (
    <ContainerExtend extensions={createNavigationModule({navigate})}>
      {children}
    </ContainerExtend>
  );
};
